/* eslint-disable camelcase */
import sharedConstants from "@lib/shared_constants.json";

// type specific to the available context objects that the endpoint is able to support
const constContextTypes = sharedConstants.APPROVALS.TYPES;
export type ApprovalContextTypes = (typeof constContextTypes)[keyof typeof constContextTypes];

export interface EngagementApprovalsContextIdApproveAllResult {
  info?: string;
  warn?: string;
}

export interface PatchEngagementApprovalsContextIdApproveAllProps {
  contextId: string;
  contextType: ApprovalContextTypes;
  isMessagingRuleApprovalOnly: boolean;
}
